import { Checkbox, FormControlLabel } from '@mui/material';

import Locale from '/b2b/common/components/Locale';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import makeStyles from '@mui/styles/makeStyles';
import styles from './ValidationCheckbox.styles';

const useStyles = makeStyles(styles);

const ValidationCheckbox = props => {
    const { checked, name, label, value, onChange, error, disabled, index, inverted } = props;
    const classes = useStyles(props);
    const handleCheckboxToggle = event => {
        const newCheckedState = event.target.checked;
        onChange && onChange(newCheckedState ? value : null, index);
    };
    const labelClass = classNames(classes.label, error ? classes.error : '');

    return (
        <FormControlLabel
            className={labelClass}
            key={value}
            label={<Locale path={label} />}
            control={
                <Checkbox
                    checked={inverted ? !checked : checked}
                    color="secondary"
                    disabled={disabled}
                    onChange={handleCheckboxToggle}
                    name={name}
                    className={classes.checkbox}
                    value={value}
                />
            }
        />
    );
};

ValidationCheckbox.propTypes = {
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    error: PropTypes.bool,
    inverted: PropTypes.bool,
    name: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func,
    required: PropTypes.bool,
    value: PropTypes.string,
    index: PropTypes.number,
};

export default ValidationCheckbox;
